import Button from './Button.component';
import model from './Button.model';

export { Button, model };

export default Button;
